module.exports = __webpack_public_path__ + "static/012-e1fa651d73f1ba70c9e8ab5cc6fa3a0d.png";